import React, { useState } from 'react';
import KTTooltip from '../../../components/KTTooltip';
import { PERFORMANCE_TYPES } from '../../../config/constants/analytics';
import { cn } from '../../../utils';
import SectionCard from '../components/SectionCard';
import BranchComparison from './BranchComparison';
import BranchPerformance from './BranchPerformance';
import BrandPerformance from './BrandPerformance';

const PerformanceSummaryCard = () => {
  const [selectedComparisonType, setSelectedComparisonType] = useState(
    PERFORMANCE_TYPES.BRANCH_COMPARISON,
  );

  const getButtonClasses = buttonType => {
    const baseClasses =
      'flex flex-col justify-start border rounded-lg px-4 py-3 w-1/3 text-left transition-colors';
    const selectedClasses = 'border-primary bg-primary-lightest';
    const unselectedClasses = 'border-grey hover:border-grey-dark';
    return cn(baseClasses, {
      [selectedClasses]: selectedComparisonType === buttonType,
      [unselectedClasses]: selectedComparisonType !== buttonType,
    });
  };

  const handlePerformanceTypeChange = type => {
    setSelectedComparisonType(type);
  };

  return (
    <SectionCard
      title="Performance"
      subtitle="Track and analyze your restaurant’s overall performance — net sales and order volume across brands and branches."
    >
      <div className="flex flex-col">
        <div className="flex gap-x-2 mb-4">
          <button
            className={getButtonClasses(PERFORMANCE_TYPES.BRAND_PERFORMANCE)}
            type="button"
            onClick={() =>
              handlePerformanceTypeChange(PERFORMANCE_TYPES.BRAND_PERFORMANCE)
            }
          >
            <p className="font-medium flex items-center gap-x-1">
              <span>Brand Performance</span>
              <KTTooltip
                content="View the sales performance of each brand, including net sales and total number of orders, to understand how each brand is contributing to your business."
                iconClassNames="kt-info text-grey-darker"
              />
            </p>
            <p className="text-grey-darker text-xs my-2 text-left">
              View the sales performance of all brands.
            </p>
          </button>
          <button
            className={getButtonClasses(PERFORMANCE_TYPES.BRANCH_PERFORMANCE)}
            type="button"
            onClick={() =>
              handlePerformanceTypeChange(PERFORMANCE_TYPES.BRANCH_PERFORMANCE)
            }
          >
            <p className="font-medium flex items-center gap-x-1">
              <span>Branch Performance</span>
              <KTTooltip
                content="Monitor individual branch performance with insights into net sales and total orders, helping you assess the success of each location."
                iconClassNames="kt-info text-grey-darker"
              />
            </p>
            <p className="text-grey-darker text-xs my-2 text-left">
              Monitor individual branch performance.
            </p>
          </button>
          <button
            className={getButtonClasses(PERFORMANCE_TYPES.BRANCH_COMPARISON)}
            type="button"
            onClick={() =>
              handlePerformanceTypeChange(PERFORMANCE_TYPES.BRANCH_COMPARISON)
            }
          >
            <p className="font-medium flex items-center gap-x-1">
              <span>Branch Comparison</span>
              <KTTooltip
                content="Compare branch performance side-by-side across different brands. Analyze net sales and order volumes to identify top-performing locations."
                iconClassNames="kt-info text-grey-darker"
              />
            </p>
            <p className="text-grey-darker text-xs my-2 text-left">
              Compare branch performance side-by-side across different brands.
            </p>
          </button>
        </div>
      </div>

      {selectedComparisonType === PERFORMANCE_TYPES.BRANCH_COMPARISON && (
        <BranchComparison />
      )}
      {selectedComparisonType === PERFORMANCE_TYPES.BRANCH_PERFORMANCE && (
        <BranchPerformance />
      )}
      {selectedComparisonType === PERFORMANCE_TYPES.BRAND_PERFORMANCE && (
        <BrandPerformance />
      )}
    </SectionCard>
  );
};

export default PerformanceSummaryCard;
